import * as React from 'react';
import { FlashbarProps, Link } from '@amzn/awsui-components-react-v3';
import { Builder } from 'builder-pattern';

interface ItemAccessWarningProps {
  itemDetailState: any;
  isAdmin: boolean;
}

export const ItemAccessWarning: React.FC<ItemAccessWarningProps> = ({
  itemDetailState,
  isAdmin
}) => {
  // Handle access warning flashbar message
  React.useEffect(() => {
    // Wait for item data to be loaded and contributor status to be determined
    if (
      itemDetailState.itemState.value.Id && 
      !isAdmin && 
      !itemDetailState.isContributor.value &&
      !itemDetailState.loading.value // Ensure data is loaded before showing warning
    ) {
      const itemName = itemDetailState.itemState.value.ItemFullName || 'this item';
      const mailtoLink = generateAccessRequestMailto(
        itemDetailState.itemState.value.ItemFullName,
        itemDetailState.itemState.value.Pm
      );
      
      // Check if this warning already exists to prevent duplicates using unique ID
      const warningExists = itemDetailState.flashbarItems.value.some((item: any) => 
        item.id === 'item-access-warning'
      );

      if (!warningExists) {
        itemDetailState.flashbarItems.setValue([
          ...itemDetailState.flashbarItems.value,
          Builder<FlashbarProps.MessageDefinition>()
            .type("warning")
            .id("item-access-warning")
            .content(
              <>
                You do not have access to edit {itemName}. <Link href={mailtoLink} external>Click here</Link> to request access from the service owner.
              </>
            )
            .dismissible(true)
            .build()
        ]);
      }
    }
  }, [
    itemDetailState.itemState.value.Id,
    isAdmin,
    itemDetailState.isContributor.value,
    itemDetailState.itemState.value.ItemFullName,
    itemDetailState.itemState.value.Pm,
    itemDetailState.flashbarItems.value,
    itemDetailState.loading.value
  ]);

  // This component doesn't render anything - it only manages the flashbar state
  return null;
};

// Utility function to generate mailto link for access requests
const generateAccessRequestMailto = (
  itemFullName: string,
  pmEmail: string
): string => {
  const pmEmailAddress = pmEmail ? `${pmEmail}@amazon.com` : '';
  const itemName = itemFullName || 'this item';
  const subject = encodeURIComponent(`Access Request for CRIPT Item: ${itemName}`);
  const body = encodeURIComponent(`Hello,

I would like to request access to edit the CRIPT Item "${itemName}".

Item URL: ${window.location.href}

Please add me as a contributor to this Item so I can make necessary updates.

Thank you`);
  
  return `mailto:${pmEmailAddress}?subject=${subject}&body=${body}`;
};
